import script from "./SearchItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchItem.vue?vue&type=script&setup=true&lang=js"

import "./SearchItem.vue?vue&type=style&index=0&id=4b572b00&lang=scss"

const __exports__ = script;

export default __exports__